<!-- src/components/GlobalMessage.vue -->
<template>
  <div v-if="show" :class="['global-message', type]">
    <div class="message-content">
      <div class="message-icon">
        <b-icon :icon="iconClass"></b-icon>
      </div>
      <div class="message-text">{{ message }}</div>
      <button class="close-btn" @click="$store.commit('message/hideMessage')" aria-label="Close">&times;</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'GlobalMessage',
  computed: {
    ...mapState('message', ['message', 'type', 'show']),
    iconClass() {
      const icons = {
        success: 'check-circle',
        error: 'exclamation-circle',
        warning: 'exclamation-triangle',
        info: 'info-circle'
      };
      return icons[this.type] || icons.info;
    }
  },
  watch: {
    show(newVal) {
      if (newVal) {
        setTimeout(() => {
          this.$store.commit('message/hideMessage');
        }, 8000); // Hide after 8 seconds
      }
    }
  }
};
</script>

<style scoped lang="scss">
.global-message {
  position: fixed;
  top: 30px;
  left: 30px;
  padding: 24px 28px;
  border-radius: 12px;
  z-index: 9999;
  width: 400px;
  min-height: 56px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  animation: slideInLeft 0.4s cubic-bezier(0.68, -0.55, 0.265, 1.55);

  @media (max-width: 768px) {
    min-width: calc(100% - 60px);
    top: 20px;
    left: 20px;
  }

  .message-content {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
  }

  .message-icon {
    font-size: 24px;
    display: flex;
    align-items: center;
  }

  .message-text {
    font-size: 16px;
    font-weight: 500;
    line-height: 1.7;
    white-space: pre-line;
    word-break: break-word;
    flex: 1;
    padding-right: 32px;
  }

  .close-btn {
    background: none;
    border: none;
    color: white;
    font-size: 22px;
    font-weight: bold;
    cursor: pointer;
    margin-left: 8px;
    padding: 0 8px;
    line-height: 1;
    transition: color 0.2s;
    position: absolute;
    right: 0;
    top: 0;
  }
  .close-btn:hover {
    color: #ddd;
  }
}

.success {
  background: linear-gradient(145deg, #4caf50, #45a049);
  color: white;
}

.error {
  background: linear-gradient(145deg, #f44336, #e53935);
  color: white;
}

.warning {
  background: linear-gradient(145deg, #ff9800, #fb8c00);
  color: white;
}

.info {
  background: linear-gradient(145deg, #2196f3, #1e88e5);
  color: white;
}

@keyframes slideInLeft {
  from {
    transform: translateX(-120%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
</style>